// @ts-nocheck
import { AppEnvironment, environment as common } from '@env/environment.common';

export const environment: AppEnvironment = {
  production: true,
  name: 'dev',
  default: 'api',
  dws_base_url: 'https://dws-dev.divinea.com',
  widget_base_url: 'https://divinea-widget-dev.web.app',
  features: {
    ...common.features,
    'automations': true,
    'sendgrid-statistics': true,
    'campaign-active': true,
    'company-management-privacy-files': true,
    'company-management-payouts': true,
    'unsubscribe-campaign': true,
    'save-template': true,
    'days-no-purchase-automation': true,
    'conversion-statistic': true,
    'subscribe-link': false,
    'subscription-conditions': true,
    'subscription-invitation-automation': true,
    'order-send-receipt-email': true,
    'product-channel-categories': true,
    'archive-contact': true,
    'winery-channel-name': true,
    'external-id-channel': true,
    'delete-channels': true,
    'winery-transactional-emails': true,
    'google-calendar-integration': true,
    'winelivery': true,
    'automatic-approve': true,
    'wineplatform': true,
    'spotty': true,
    'filters-widget': true,
    'country-in-reservation': true,
    'category-product': true,
    'availability-data-pdf': true,
    'close-matching-slot-languages-in-the-same-experience': true,
    'automatically-accept-reservations-on-same-slot': true
  },
  values: {
    ...common.values,
    'fcm-worker': 'assets/js/firebase-messaging-sw-dev.js',
    firebaseConfig: {
      apiKey: "AIzaSyC1TWN6IkoUzalJzC62x-JlnRlt9pgcw4E",
      authDomain: "divinea-dev-bdda0.firebaseapp.com",
      projectId: "divinea-dev-bdda0",
      storageBucket: "divinea-dev-bdda0.appspot.com",
      messagingSenderId: "796730530425",
      appId: "1:796730530425:web:4db1ed3da6f0d3f09412a8",
      measurementId: "G-WYPB9HSBCH"
    },
    firebaseAuthKey: 'BIc7f74bl4oG4RW0P5x-tmH5iadtAQQPLLcZYRG57HM-YbhpJ99KFzYp_R5QwWceYuGgDw9Um9dLfuAnG3-hBW0',
    dateSendGridStatistics: '2021-03-26',
    'outlook-redirect-uri': 'https://dws-dev.divinea.com',
    divinea: 'divinea-dev.web.app',
    googleAnalyticsId: 'G-13JWHSY38X',
    unlayer_project_key: 267837,
    wineplataformOrders:  'https://api-crm-dev.divinea.com/api/wineplatform/webhook',
    wineplataformCustomers:  'https://api-crm-dev.divinea.com/api/wineplatform/contact-webhook ',
    wineplataformSubscription:  'https://api-crm-dev.divinea.com/api/wineplatform/privacy-contact-webhook',
    version_postfix: 'dev',
    version_ribbon: 'dev',
    'preorder-url': 'https://preorders-dev.divinea.com',
  },
  hosts: {
    crm: {
      host: 'api-crm-dev.divinea.com',
      protocol: 'https',
      port: '',
      root: '/api/',
      endpoints: {
        ...common.hosts.crm.endpoints
      }
    },
    v2: {
      host: 'api-dev.divinea.com',
      protocol: 'https',
      port: '',
      root: '/api/v2/',
      endpoints: {
        ...common.hosts.v2.endpoints
      }
    },
    v1: {
      host: 'api-dev.divinea.com',
      protocol: 'https',
      port: '',
      root: '/api/v1',
      endpoints: {
        ...common.hosts.v1.endpoints
      }
    },
    divinea: {
      site: 'divinea-staging.web.app'
    },
    websocket: {
      host: 'dev.events.ws.wine-suite.com',
      protocol: 'wss',
      port: '',
      root: 'ws'
    },
    divineaCom: {
      host: 'divinea.com',
      protocol: 'https',
      port: '',
      root: '/',
      endpoints: {
        ...common.hosts.divineaCom.endpoints
      }
    }
  }
};